import { cn } from '../../lib/utils';

/**
 * Retrieval confidence, 0-100.
 *
 * The bands mirror the runtime policy: below the escalation trigger the agent
 * hands off, between trigger and threshold it must cite sources, above it
 * answers freely. Colour follows the same story.
 */
const ConfidenceBar = ({ value = 0, threshold = 75, escalateAt = 40, showLabel = true, className }) => {
  const clamped = Math.max(0, Math.min(100, Math.round(value)));
  const band =
    clamped < escalateAt ? 'escalate' : clamped < threshold ? 'cited' : 'confident';

  const barColor = {
    escalate: 'bg-destructive',
    cited: 'bg-amber-500',
    confident: 'bg-emerald-500',
  }[band];

  const textColor = {
    escalate: 'text-destructive',
    cited: 'text-amber-600 dark:text-amber-400',
    confident: 'text-emerald-600 dark:text-emerald-400',
  }[band];

  return (
    <div className={cn('space-y-1.5', className)}>
      {showLabel && (
        <div className="flex justify-between text-[10px] font-medium uppercase tracking-wider text-muted-foreground">
          <span>Confidence</span>
          <span className={textColor}>{clamped}%</span>
        </div>
      )}
      <div className="h-1.5 w-full rounded-full bg-muted overflow-hidden relative">
        <div
          className={cn('h-full rounded-full transition-all duration-500', barColor)}
          style={{ width: `${clamped}%` }}
        />
        {/* Threshold ticks make the policy visible rather than implied. */}
        <span
          className="absolute top-0 h-full w-px bg-foreground/25"
          style={{ left: `${escalateAt}%` }}
          title={`Escalation trigger: ${escalateAt}%`}
        />
        <span
          className="absolute top-0 h-full w-px bg-foreground/25"
          style={{ left: `${threshold}%` }}
          title={`Confidence threshold: ${threshold}%`}
        />
      </div>
    </div>
  );
};

export default ConfidenceBar;
